import { linkStatusPieChartColor } from "../../../../../reusableComponents/constants";

export const PieChartPaymentMethodSplitSchema = (
  paymentMethodSplitData,
  paymentMethodSliptCountLocale,
  pieChartDisplayOption = "value"
) => {
  function compare(a, b) {
    return (
      parseFloat(
        pieChartDisplayOption === "value"
          ? b.paymentTypeGmvPercent
          : b.paymentTypeCountPercent
      ) -
      parseFloat(
        pieChartDisplayOption === "value"
          ? a.paymentTypeGmvPercent
          : a.paymentTypeCountPercent
      )
    );
  }
  if (paymentMethodSplitData) {
    paymentMethodSplitData.sort(compare);
  }

  const sumOfStatusGmvLocale = paymentMethodSliptCountLocale?.gmvSumLocale || 0;
  const sumOfStatusCountLocale =
    paymentMethodSliptCountLocale?.totalCountLocale || 0;

  const paymentMethodSplitTableData =
    paymentMethodSliptCountLocale?.gmvSum >= 1
      ? [
        ...paymentMethodSplitData?.map((item) => ({
          Payment_Method: item?.paymentMethodTypeLocale,
          value: item?.gmvLocaleFull,
          // value: item?.gmvLocale,
          value_sort: item?.gmv,
          percentage1: item?.paymentTypeGmvPercent + "%",
          percentage1_sort: parseFloat(item?.paymentTypeGmvPercent),
          count: item?.paymentMethodTypeCount,
          // count: item?.paymentMethodTypeCountLocale,
          count_sort: item?.paymentMethodTypeCount,
          percentage2: item?.paymentTypeCountPercent + "%",
          percentage2_sort: parseFloat(item?.paymentTypeCountPercent),
          sort: true,
        })),
      ]
      : paymentMethodSplitData?.map((item) => ({
        Payment_Method: item?.paymentMethodTypeLocale,
        value: item?.gmvLocaleFull,
        // value: item?.gmvLocale,
        percentage1: item?.paymentTypeGmvPercent + "%",
        percentage1_sort: parseFloat(item?.paymentTypeGmvPercent),
        count: item?.paymentMethodTypeCount,
        // count: item?.paymentMethodTypeCountLocale,
        percentage2: item?.paymentTypeCountPercent + "%",
        percentage2_sort: parseFloat(item?.paymentTypeCountPercent),
        count_sort: item?.paymentMethodTypeCount,
        value_sort: item?.gmv,
      }));

  const chartOptions = {
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        enabled: true,
        callbacks: {
          label: function (context) {
            let label = context?.label || "";
            if (label) {
              label += ": ";
            }
            if (context?.parsed) {
              label += context.parsed + "%";
            }
            return label;
          },
        },
      },
      legend: {
        padding: 20,
        position: "right",
        labels: {
          usePointStyle: true,
          generateLabels: function (chart) {
            const data = chart?.data;
            if (data?.labels?.length && data?.datasets?.length) {
              return data?.labels.map(function (label, i) {
                const value = data?.datasets[0].data[i];
                return {
                  text: label + ": " + value + "%",
                  fillStyle: data?.datasets[0].backgroundColor[i],
                  hidden:
                    isNaN(data?.datasets[0].data[i]) ||
                    chart.getDatasetMeta(0).data[i].hidden,
                  index: i,
                };
              });
            }
            return [];
          },
        },
      },
      datalabels: {
        formatter: (value, ctx) => {
          return value.toLocaleString();
        },
        color: "#fff",
      },
    },
  };

  const chartData = {
    labels: paymentMethodSplitData?.map((item) => item.paymentMethodTypeLocale),
    datasets: [
      {
        label: "Payment Category Split by Transaction Count",
        data: paymentMethodSplitData.map((item) =>
          pieChartDisplayOption === "value"
            ? item.paymentTypeGmvPercent
            : item.paymentTypeCountPercent
        ),
        backgroundColor: linkStatusPieChartColor,
        borderColor: "#fff",
        borderWidth: 1,
        hoverBackgroundColor: linkStatusPieChartColor,
      },
    ],
  };

  let firstMaxPaymentTypeCountPercent = 0;
  let firstMaxPaymentMethodType = "";
  let secondMaxPaymentTypeCountPercent = 0;
  let secondMaxPaymentMethodType = "";

  if (paymentMethodSplitData.length >= 1) {
    firstMaxPaymentTypeCountPercent =
      paymentMethodSplitData[0].paymentTypeCountPercent;
    firstMaxPaymentMethodType =
      paymentMethodSplitData[0].paymentMethodTypeLocale;
  }

  if (paymentMethodSplitData.length >= 2) {
    secondMaxPaymentTypeCountPercent =
      paymentMethodSplitData[1].paymentTypeCountPercent;
    secondMaxPaymentMethodType =
      paymentMethodSplitData[1].paymentMethodTypeLocale;
  }

  return {
    paymentMethodSplitData,
    paymentMethodSliptCountLocale,
    chartData,
    chartOptions,
    paymentMethodSplitTableData,
  };
};
